import type { FC, SVGProps } from 'react';

export const FileAddIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7992_20870)">
      <rect width="14" height="14" fill="white" fillOpacity="0.01" />
      <g clipPath="url(#clip1_7992_20870)">
        <path
          fill="white"
          d="M8.6377 0C8.77051 0 8.89746 0.0537109 8.99121 0.147461L12.3535 3.50977C12.4472 3.60351 12.5 3.73149 12.5 3.86426V13.5C12.5 13.7766 12.2766 14 12 14H2C1.72363 13.9998 1.5 13.7764 1.5 13.5V0.5C1.50009 0.223656 1.72369 0.00022758 2 0H8.6377ZM2.625 1.125V12.875H11.375V5.15625H8C7.8261 5.15614 7.6591 5.08684 7.53613 4.96387C7.41325 4.84082 7.34375 4.67391 7.34375 4.5V1.125H2.625ZM7.375 6.25C7.44369 6.25 7.49991 6.30633 7.5 6.375V8.0625H9.1875C9.25619 8.0625 9.31241 8.11883 9.3125 8.1875V8.9375C9.3125 9.00625 9.25625 9.0625 9.1875 9.0625H7.5V10.75C7.5 10.8188 7.44375 10.875 7.375 10.875H6.625C6.55644 10.8748 6.5 10.8186 6.5 10.75V9.0625H4.8125C4.74394 9.06227 4.6875 9.00611 4.6875 8.9375V8.1875C4.68759 8.11897 4.744 8.06273 4.8125 8.0625H6.5V6.375C6.50009 6.30647 6.5565 6.25023 6.625 6.25H7.375ZM8.40625 4.09375H11.3477L8.40625 1.15332V4.09375Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7992_20870">
        <rect width="14" height="14" fill="white" />
      </clipPath>
      <clipPath id="clip1_7992_20870">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
